/**
 * TRAD-3759 — 약관 종류. 서버 `TermsType`(backend TRAD-3756) 그대로. 🔴 서버가 값을 늘려도 클라가 깨지지 않게 응답 쪽은
 * `string` 으로 받고 `CONSENT_TERMS_TYPE`(server-enum) 으로만 분기한다 — 이 유니언은 «클라가 보내는» 쪽에만 쓴다.
 */
export type TermsType = 'EULA' | 'TERMS_OF_SERVICE' | 'PRIVACY_POLICY' | 'AGE_OVER_14';
export type LangType = 'KO' | 'EN';

/**
 * 🔴 TRAD-3251 — 현재 로케일을 약관 API 의 `langType` 으로 옮긴다.
 *
 * 약관 본문은 **프론트 문자열이 아니라 서버가 주는 HTML**(`terms.contents`)이고, 백엔드에는
 * **EN 약관이 이미 있다**(2026-09-08 dev 실측: `langType=EN` → 4288자 · 영단어 593).
 * 그런데 호출부 3곳이 전부 기본값 `'KO'` 로 불러서 **EN 사용자에게도 한국어 약관이 떴다.**
 * 카탈로그로 이관할 것이 아니라 **이미 있는 것을 안 쓰고 있던 것**이다.
 *
 * 🔴 매핑을 여기 한 곳에 두는 이유: 호출부가 셋이라 각자 `getLocale() === 'ko' ? 'KO' : 'EN'`
 * 을 쓰면 **한 곳만 고쳐도 티가 안 난다**(약관은 세 화면에서 열린다 — 전문·가입 동의·모달).
 */
export const toLangType = (locale: string): LangType => (locale === 'ko' ? 'KO' : 'EN');

export interface TermsDetailResponse {
  termsId: string;
  termsType: TermsType;
  langType: LangType;
  version: string;
  contents: string;
  activated: boolean;
  createdDatetime: string;
  createdBy: string;
  updateDatetime: string;
  updatedBy: string;
}

export interface TermsAcceptRequest {
  termsType: TermsType;
  version: string;
}

export interface TermsAcceptResponse {
  termsType: TermsType;
  version: string;
  accepted: boolean;
  acceptedAt: string;
}

export interface TermsAcceptStatusResponse {
  termsType: TermsType;
  version: string;
  accepted: boolean;
  acceptedAt: string | null;
}

/**
 * TRAD-3759 — `GET /api/members/terms/required-missing` · `POST /api/members/terms/accept-batch` 응답 한 줄
 * (backend `RequiredConsentsRes.Item`, 2026-10-18 dev 실응답으로 확인). `termsType` 은 서버가 아는 «모든» 값이 올 수
 * 있으므로 문자열로 받는다. `displayName` 은 모르는 종류일 때만 쓰는 폴백이다(정본표 282329090 §5-24).
 */
export interface RequiredConsentItem {
  termsType: string;
  version: string;
  previouslyAcceptedVersion: string | null;
  documentUrl: string | null;
  displayName: string;
}

export interface RequiredConsentsResponse {
  items: RequiredConsentItem[];
}

export interface ConsentAcceptItem {
  termsType: string;
  version: string;
}

export interface AcceptConsentsRequest {
  items: ConsentAcceptItem[];
}
